import styled from "styled-components";
import { Colors } from "~/config/Colors";

export const ItemModulo = styled.div`
  display: flex;
  justify-content: center;
`;

export const ItemButtonModulo = styled.button`
  position: relative;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  /* padding: 0 1em; */
  border-radius: 0.375em;
  border: 0;
  width: 2em;
  height: 2em;

  :hover {
    background: ${Colors.Color11};
  }

  ${({ selected }) => {
    if (selected) {
      return `
        background: ${Colors.Color11};
      `;
    } else {
      return `
        background: ${Colors.Color2};
      `;
    }
  }}

  img {
    border-radius: 0.375em;
    width: 1.1em;
  }
`;